import { useEffect, useRef } from 'react';
import { useSetRecoilState } from 'recoil';

import { useChatMessages } from '@chainlit/react-client';

import { composerInputState } from '@/state/chat';

export default function ComposerDraftReset() {
  const { threadId } = useChatMessages();
  const setComposerInput = useSetRecoilState(composerInputState);
  const prevThreadId = useRef<string | undefined>(threadId);

  useEffect(() => {
    const prev = prevThreadId.current;
    prevThreadId.current = threadId;
    // Clear the draft only when leaving a previously-active conversation
    // (New chat -> undefined, or switching to a different thread). Keep it for
    // the undefined -> defined creation transition and the URL-only remount.
    if (prev && threadId !== prev) {
      setComposerInput('');
    }
  }, [threadId, setComposerInput]);

  return null;
}
